import trackScreenView from 'modules/analytics/trackScreenView';
import { trackEvent } from 'modules/analytics';

export type SpotifyConnectComponent =
  | 'music_and_talk'
  | 'paid_subscriptions'
  | 'account_settings'
  | 'automated_ads';

export const events = {
  screenView: (
    screenName: string,
    location: string,
    component: SpotifyConnectComponent
  ) =>
    trackScreenView(screenName, {
      location,
      component,
    }),
  connectToSpotifyClicked: (component: SpotifyConnectComponent) =>
    trackEvent(
      'connect_to_spotify_clicked',
      { component },
      { providers: [mParticle] }
    ),
  connectToSpotifyConfirmationClicked: (component: SpotifyConnectComponent) =>
    trackEvent(
      'connect_to_spotify_confirmation_clicked',
      { component },
      { providers: [mParticle] }
    ),
  spotifyConnectedOauthSuccess: (component: SpotifyConnectComponent) =>
    trackEvent(
      'spotify_connected_oauth_success',
      { component },
      { providers: [mParticle] }
    ),
  spotifyConnectedOauthFailure: (component: SpotifyConnectComponent) =>
    trackEvent(
      'spotify_connected_oauth_failure',
      { component },
      { providers: [mParticle] }
    ),
  spotifyPayoutsModalClicked: () =>
    trackEvent(
      'spotify_payouts_modal_clicked',
      { component: 'automated_ads', location: 'money' },
      { providers: [mParticle] }
    ),
  spotifyPayoutsActiveModalClicked: () =>
    trackEvent(
      'spotify_payouts_active_modal_clicked',
      { component: 'automated_ads', location: 'money' },
      { providers: [mParticle] }
    ),
  automatedAdsDeactivateClicked: () =>
    trackEvent(
      'automated_ads_deactivate_clicked',
      { component: 'automated_ads', location: 'money' },
      { providers: [mParticle] }
    ),
  automatedAdsViewEarningsClicked: () =>
    trackEvent(
      'automated_ads_view_earnings_clicked',
      { component: 'automated_ads', location: 'money' },
      { providers: [mParticle] }
    ),
};
